'use client';

import classNames from 'classnames';
import Link from 'next/link';
import { useState } from 'react';

import { NavToggle } from '~components/Headers/NavToggle/NavToggle';
import { Image } from '~components/Image/Image';
import { LayoutContainer } from '~components/LayoutContainer/LayoutContainer';
import { LayoutContainerMods } from '~components/LayoutContainer/LayoutContainer.types';
import { env } from '~constants/env';
import { ButtonConsult } from '~containers/Buttons/ButtonConsult/ButtonConsult';
import { useBreakpoints } from '~hooks/useBreakpoints';
import { ThemesNames } from '~types/Theme.types';
import { URLS } from '~types/Urls.types';

import styles from './HeaderCloud.module.scss';
import { HeaderCloudProps } from './HeaderCloud.types';
import { HeaderCloudCatalog } from './HeaderCloudCatalog/HeaderCloudCatalog';
import { HeaderCloudUser } from './HeaderCloudUser/HeaderCloudUser';

const LOGO = {
  small: `${process.env.STATIC}/images/icons/logos/vkc_cube.svg`,
  large: `${process.env.STATIC}/images/icons/logos/vkc_inline_black.svg`,
};

export const HeaderCloud = ({
  mod = ThemesNames.White,
  catalog,
  className,
  headerRef,
}: HeaderCloudProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [, { isMobile, isDesktop }] = useBreakpoints();
  const toggleActiveItem = () => {
    return setOpen((prevState) => !prevState);
  };
  const handleClose = (e: MouseEvent) => {
    e.stopPropagation();
    setOpen(false);
  };

  function MainLogo() {
    return (
      <Link
        href={env.blogConfig?.originUrl || URLS.OriginCloudVk}
        className={classNames(styles.logoLink, {
          [styles.indexTop]: open,
        })}
      >
        <Image
          className={styles.logoImg}
          src={isMobile ? LOGO.small : LOGO.large}
          alt="VK Cloud"
        />
      </Link>
    );
  }

  return (
    <>
      {open && isDesktop && <div className={styles.overlay}></div>}
      <header
        className={classNames(styles.header, className, {
          [styles[mod]]: mod,
          [styles.catalogActive]: open,
        })}
        ref={headerRef}
        data-testid="header"
      >
        <LayoutContainer mods={[LayoutContainerMods.Inner]}>
          <div className={styles.container}>
            {catalog ? (
              <div className={styles.logoWrapper}>
                <div className={styles.productMenu}>
                  {(!isDesktop || catalog) && (
                    <NavToggle
                      mod={mod}
                      active={open}
                      setActive={toggleActiveItem}
                      className={classNames(styles.navToggle, {
                        [styles.active]: open,
                      })}
                    >
                      <span className={styles.productsIcon}>
                        <i>Продукты</i>
                      </span>
                    </NavToggle>
                  )}

                  <HeaderCloudCatalog
                    items={catalog}
                    isOpen={open}
                    onClose={(e) => handleClose(e)}
                    mod={mod}
                  />
                </div>
                <MainLogo />
              </div>
            ) : (
              <MainLogo />
            )}
            <div
              className={classNames(styles.buttons, {
                [styles.indexTop]: open && !isDesktop,
              })}
            >
              {isDesktop && (
                <ButtonConsult
                  logo={{
                    src: `${env.static}/images/icons/logos/vkc_cube.svg`,
                    alt: 'VK Logo Cube',
                  }}
                  className={styles.buttonConsult}
                  dataTest="header.consultationButton"
                  formLabel="main-menu"
                />
              )}
              <HeaderCloudUser mod={mod} />
            </div>
          </div>
        </LayoutContainer>
      </header>
    </>
  );
};
